import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getCallReportFileRequest, getCustomerCallsRequest, getCustomerCallTypesRequest, getCustomerContactsRequest } from '../apiRequests/callReportRequests'
import { getAllMusicOnHold } from '../apiRequests/commonRequests'
import { getNotificationCount } from '../apiRequests/notificationRequest'
import { CallReport } from '../../interfaces/callReport'





function* handleGetCallReport(action) {
    try {
        const response = yield call(getCustomerCallsRequest, action.params)
        const callReport = new CallReport()
        callReport.mapper(response)
        yield put({
            type: types.CALL_REPORT_SUCCESS,
            action: { data: callReport?.callReport },
        })
    } catch (error) {
        yield put({
            type: types.CALL_REPORT_ERROR,
            error: error.response,
        })
    }
}

//Call direct****************************************************************
function* handleGetCallDirectReport(action) {
    try {
        const response = yield call(getCustomerCallsRequest, action.params)
        yield put({
            type: types.CALL_REPORT_CALL_DIRECT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.CALL_REPORT_CALL_DIRECT_ERROR,
            error: error.response,
        })
    }
}
//************************************************************************* */



function* handleGetCallReportToExport(action) {
    try {

        const response = yield call(getCustomerCallsRequest, action.params)
        const callReport = new CallReport()
        callReport.mapper(response)
        yield put({
            type: types.GET_CALL_REPORT_TO_EXPORT_SUCCESS,
            action:  callReport?.callReport,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_REPORT_TO_EXPORT_ERROR,
            error: error.response,
        })
    }
}



function* handleGetCustomerContacts() {
    try {

        const response = yield call(getCustomerContactsRequest)
        yield put({
            type: types.GET_CONTACTS_REPORT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CONTACTS_REPORT_ERROR,
            error: error.response,
        })
    }
}


function* handleGetCallTypes() {
    try {

        const response = yield call(getCustomerCallTypesRequest)


        yield put({
            type: types.GET_CUSTOMER_CALL_TYPES_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CUSTOMER_CALL_TYPES_ERROR,
            error: error.response,
        })
    }
}


function* handleGetCallReportFile(action) {
    try {

        const response = yield call(getCallReportFileRequest(action.params))


        yield put({
            type: types.GET_CALL_REPORT_FILE_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.GET_CALL_REPORT_FILE_ERROR,
            error: error,
        })
    }
}




function* watcherCallReportSaga() {
    yield takeEvery(types.CALL_REPORT_REQUEST, handleGetCallReport)
    yield takeEvery(types.GET_CONTACTS_REPORT_REQUEST, handleGetCustomerContacts)
    yield takeEvery(types.GET_CUSTOMER_CALL_TYPES_REQUEST, handleGetCallTypes)
    yield takeEvery(types.GET_CALL_REPORT_TO_EXPORT_REQUEST, handleGetCallReportToExport)
    yield takeEvery(types.GET_CALL_REPORT_FILE_REQUEST, handleGetCallReportFile)
    yield takeEvery(types.CALL_REPORT_CALL_DIRECT_REQUEST, handleGetCallDirectReport)

}

export default watcherCallReportSaga
